"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsLoggedIn = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var useIsLoggedIn = function () {
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), account = _a.account, accessToken = _a.accessToken;
    var isLoggedIn = (0, react_1.useMemo)(function () { return Boolean((accessToken === null || accessToken === void 0 ? void 0 : accessToken.length) && (account === null || account === void 0 ? void 0 : account.email)); }, [account, accessToken]);
    return isLoggedIn;
};
exports.useIsLoggedIn = useIsLoggedIn;
//# sourceMappingURL=useIsLoggedIn.js.map